import { render, staticRenderFns } from "./listarModelosDesafios.vue?vue&type=template&id=1bdf6e7a&"
import script from "./listarModelosDesafios.vue?vue&type=script&lang=js&"
export * from "./listarModelosDesafios.vue?vue&type=script&lang=js&"
import style0 from "./listarModelosDesafios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports